

































import Vue from 'vue';

import SocialIcons from '@/components/layout/SocialIcons.vue';
import {eventBus} from '@/event-bus';
import {NavItems, RouteNames} from '@/typings/types';


export default Vue.extend({
  name: 'navigation',
  components: {
    SocialIcons,
  },
  data () {
    return {
      RouteNames,
      eventBus,
      sidebarIsOpen: false,
      navItems: <NavItems[]> [
        {title: 'Home', hash: '#hero'},
        {title: 'About', hash: '#about'},
        {title: 'Services', hash: '#services'},
        {title: 'testimonials', hash: '#testimonials'},
        {title: 'Gallery', hash: '#gallery'},
        {title: 'Contact Me', hash: '#contact'},
      ],
      navbarClass: <string[]> [
        'position-fixed',
        'rounded-0',
        'border-bottom',
        'shadow-sm',
        'is-being-scrolled',
      ],
    };
  },
  methods: {
    triggerSidebar () {
      this.eventBus.$emit('open-sidebar');
    },

    fixedNavigation () {
      document.addEventListener('scroll', () => {
        const navbar = document.querySelector('.navbar');

        if (window.scrollY >= 200) {
          navbar!.classList.add(...this.navbarClass);

          return;
        }

        navbar!.classList.remove(...this.navbarClass);
      });
    },
  },

  mounted () {
    if (window.innerWidth >= 768) {
      this.fixedNavigation();
    }
  },
});
